const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Managers Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Managers', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  
  return $resource(appConfiguration.apiUrl + '/learn/v3/managers/:subresource/:option/:reportId', null, {
    content: {params: {subresource: '', option: 'content'}, method: 'GET', isArray: true},
    users: {params: {subresource: '', option: 'users'}, method: 'POST', isArray: true},
    individualAssignments: {params: {subresource: 'individual-assignments', option: 'users'}, method: 'GET', isArray: true},
    searchAssignments: {params: {subresource: 'search-assignments', option: 'users'}, method: 'GET', isArray: true},
    assessments: {params: {subresource: '', option: 'assessments'}, method: 'GET', isArray: true},
    openScores: {params: {subresource: 'scores'}, method: 'GET', isArray: true},
    dashboardStats: {params: {option: 'dashboard-stats'}, method: 'GET', isArray: false},
    assignments: {params: {subresource: '', option: 'assignments'}, method: 'POST', isArray: false},
    report: {params: {subresource: '', option: 'report', reportId: ''}, method: 'GET', isArray: false},
    queryUpdate: {params: {subresource: 'change-reports'}, method: 'POST', isArray: false}
  });

}]);
